import { Container, Image, TextArea, Form, Select } from "semantic-ui-react"
import logo from "../../assets/logo.png"
import signature from "../../assets/signature.png"
import { useSelector, useDispatch } from "react-redux"
import { setLetterStep1DataProjectNeed, setLetterStep1DataAddedValueOfProgrammApproch, setLetterStep1DataAdditional, setLetterStep1DataObjectiveContribution, setLetterStep1DataPartnershipRelevance, setLetterContactPoint } from "../../redux/projectSlice"

const Step1DetailApproval = () => {
    const dispatch = useDispatch();
    const projectState = useSelector(state => state.project);

    const handleChangeTextArea = (e, data) => {
        if (data.className.split(' ').find(class_ => class_ === 'project-need')) {
            dispatch(setLetterStep1DataProjectNeed(data.value));
        } else if (data.className.split(' ').find(class_ => class_ === 'contribution')) {
            dispatch(setLetterStep1DataObjectiveContribution(data.value));
        } else if (data.className.split(' ').find(class_ => class_ === 'added-value-project')) {
            dispatch(setLetterStep1DataAddedValueOfProgrammApproch(data.value));
        } else if (data.className.split(' ').find(class_ => class_ === 'partnership-relevance')) {
            dispatch(setLetterStep1DataPartnershipRelevance(data.value));
        } else if (data.className.split(' ').find(class_ => class_ === 'additional')) {
            dispatch(setLetterStep1DataAdditional(data.value));
        }
    }

    const handleSelectChange = (e, data) => {
        dispatch(setLetterContactPoint(data.value));
    }

    const renderHeaderDestination = () => {
        const lp = projectState.leadPartner
        const contact = lp.contacts.filter(contact => contact.type === 'ContactPerson')[0]
        return (
            <div>
                <Container textAlign='left'>
                    <p>
                        {contact.title} {contact.firstName} {contact.lastName}<br />
                        {lp.nameInEnglish}<br />
                        {lp.addresses[0].houseNumber} {lp.addresses[0].street}<br />
                        {lp.addresses[0].postalCode} {lp.addresses[0].city}<br />
                        {lp.addresses[0].country}<br />
                    </p>
                </Container>
                <Container textAlign='right'>
                    <p>
                        Lille, {projectState.letter?.commission?.step1LetterDate}
                    </p>
                </Container>
            </div>
        )
    }

    const renderLetter = () => {
        const letter = projectState.letter
        const project = projectState.project
        const lp = projectState.leadPartner
        const contact = lp.contacts.filter(contact => contact.type === 'ContactPerson')[0]
        const title = project.title.filter(title => title.language === 'EN')[0].translation
        const selectedJsOfficer = projectState.jsOfficers.filter(jsOfficer => jsOfficer.value === letter?.jsOfficer)
        const selectedContactPoint = projectState.contactPoints.filter(contactPoint => contactPoint.value === letter?.contactPoint)

        return (
            <Container textAlign='justified' className="espace-haut">
                <p>Dear {contact.title} {contact.lastName},</p>
                <p>Congratulations! Your step 1 application <span className="text-accent">{project.customIdentifier} {title} ({project.acronym})</span> has been approved by the NWE Monitoring Committee which took place on {letter?.commission?.step1Date}, in {letter?.commission?.step1Location}. We kindly ask you to inform your project partners.</p>
                <p>Please note that the step 1 approval <span className="text-accent">is not a decision on funding</span>, but it allows you to submit a full step 2 project proposal. The NWE Monitoring Committee has drafted a list of conclusions that serve as recommendations for you to consider at step 2 (annexed to this letter).</p>
                <p>The complete step 2 application form must be submitted on Jems by 12.00 CET (midday) on {letter?.commission?.step2SubmissionDeadline}.</p>
                <p><span className="text-accent">A Step 2 Workshop</span> will take place on {letter?.commission?.step2WorkshopDate} in Lille, France. Please save the date as this workshop is mandatory for Lead Partners of all projects. A maximum of two representatives per project are invited, preferably persons closely involved in the preparation of the application form. </p>
                <p>Please contact your responsible Contact Point <Select placeholder="Select contact point" defaultValue={selectedContactPoint} options={projectState.contactPoints} className="invisible-print" onChange={handleSelectChange} /> {!letter?.contactPoint ? undefined : <span className="invisible-screen">{letter?.contactPoint[0]} <span className="text-accent">({letter?.contactPoint[1]})</span></span>} as soon as possible to discuss the recommendations and the next steps to submit your step 2 application.</p>
                <p>Should you have a complaint regarding this decision, you can find more information regarding the available options in Chapter 7 of the Programme Manual.</p>
                <p>Kind regards,</p>
                <Image src={signature} size='small' className="espace-haut-large" />
                <p>David Grzegorzewski</p>
                <p> Programme Director</p>
            </Container>
        )
    }

    // const renderContactPoint = () => {
    //     const lp = projectState.leadPartner
    //     let codePays = lp.addresses.filter(address => address.type === 'Organization')[0].countryCode
    //     if (codePays === 'BE') {
    //         codePays = lp.addresses.filter(address => address.type === 'Organization')[0].nutsRegion2Code.substring(0, 3)
    //         console.log(codePays)
    //     }
        
    //     const contactPoints = projectState.letterContactPoints.filter(contactPoint => contactPoint.codePays === codePays)
    //     if (contactPoints.length === 0) {
    //         //Sconsole.warn('contact point not found !!');
    //         return(<Message negative><Message.Header>We didn't find the contact point for this area: ({codePays})</Message.Header></Message>)
    //     } else {
    //         return (
    //             <span>
    //                 {contactPoints.map(ct => (
    //                     <span>{ct.contact} (<a href={"mailto:"+ct.email}>{ct.email}</a>), </span> 
    //                 ))}
    //                 contact point for {contactPoints[0].pays}
    //             </span>
    //         )
    //     }
    // }

    // const renderProjectPoints = (data) => {
    //     const listePoints = data.split(' \n').map(point => point.replace('\n-', '').replace(' /^-+/'))//
    //     return (
    //         <List bulleted>
    //             {listePoints.map(point => {
    //                 return <List.Item>{point}</List.Item>
    //             })}
    //         </List>
    //     )
    // }

    const renderLetterDetails = () => {
        const letter = projectState.letter
        return (
            <Container textAlign='justified' >
                <h3>Recommendations for Step2 development</h3>
                <div className="prevent-page-break little-margin">
                    {letter?.step1Data?.projectNeed ? <h4>Project need and justification</h4> : <h4 className="invisible-print">Project need and justification</h4>}
                    <Form>
                        <TextArea className="notification-letter-text-area invisible-print project-need" onChange={handleChangeTextArea} value={letter?.step1Data?.projectNeed}></TextArea>
                    </Form>
                    <p className="line-break invisible-screen">{letter?.step1Data?.projectNeed}</p>
                </div>

                <div className="little-margin">
                    {letter?.step1Data?.objectiveContribution ? <h4>Contribution to Programme objectives</h4> : <h4 className="invisible-print">Contribution to Programme objectives</h4>}
                    <Form>
                        <TextArea className="notification-letter-text-area invisible-print contribution" onChange={handleChangeTextArea} value={letter?.step1Data?.objectiveContribution}></TextArea>
                    </Form>
                    <p className="line-break invisible-screen">{letter?.step1Data?.objectiveContribution}</p>
                    {/* <p></p>
                    <p>- The result indicators presented in the application form must be revised. The following should be considered:</p>
                    <p><span className="text-accent-italic">Result indicator: Joint strategies and action plans taken up by organisations (RCR 79)</span></p>
                    <p>- The partnership is reminded that the result indicator ‘RCR 79 Joint strategies and action plans taken up by organisations’ relates to the output indicator ‘RCO83 Strategies and action plans jointly developed‘. As such, project strategies and action plans must first be jointly developed, before they are taken up by project partners or organisations external to the project.</p>
                    <p>- The indicator ‘RCR 79 Joint strategies and action plans taken up by organisations’ counts the number of joint strategies and action plans (and not individual actions) being adopted and starting to get implemented by organisations during the project as a result of uptake/upscale activities.</p>
                    <p>- The target value for the indicator ‘RCR 79 Joint strategies and action plans taken up by organisations’ should be realistic and relate only to strategies and action plans being practically adopted and starting to get implemented during the project lifetime.</p>
                    <p><span className="text-accent-italic">Result indicator: Solutions taken up or up-scaled by organisations (RCR 104)</span></p>
                    <p>- The partnership is reminded that the result indicator ‘RCR 104 Solutions taken up or up-scaled by organisations’ relates to the output indicator ‘RCO116 Jointly developed solutions‘. Thus, project solutions must first be jointly developed before they are taken up by project partners or organisations external to the project.</p>
                    <p>- The target value for the indicator ‘RCR 104 Solutions taken up or up-scaled by organisations’ should be realistic and relate only to solutions tangibly adopted and implemented during the project.</p>
                    <p><span className="text-accent-italic">Result indicator: Completion of joint training schemes (RCR 81)</span></p>
                    <p>- Joint training scheme(s) envisaged by the project need to be jointly developed and/or delivered by the partners of at least two countries participating in the project.</p>
                    <p>- The total number of participants must be realistic and clearly linked to the training scheme delivered by the project partners within the thematic project context.</p> */}
                </div>

                <div className="prevent-page-break little-margin">
                    {letter?.step1Data?.addedValueOfProgrammApproch ? <h4>Added value of project approach</h4> : <h4 className="invisible-print">Added value of project approach</h4>}
                    <Form>
                        <TextArea className="notification-letter-text-area invisible-print added-value-project" onChange={handleChangeTextArea} value={letter?.step1Data?.addedValueOfProgrammApproch}></TextArea>
                    </Form>
                    <p className="line-break invisible-screen">{letter?.step1Data?.addedValueOfProgrammApproch}</p>
                </div>

                <div className="prevent-page-break little-margin">
                    {letter?.step1Data?.partnershipRelevance ? <h4>Partnership relevance</h4> : <h4 className="invisible-print">Partnership relevance</h4>}
                    <Form>
                        <TextArea className="notification-letter-text-area invisible-print partnership-relevance" onChange={handleChangeTextArea} value={letter?.step1Data?.partnershipRelevance}></TextArea>
                    </Form>
                    <p className="line-break invisible-screen">{letter?.step1Data?.partnershipRelevance}</p>
                </div>

                <div className="prevent-page-break little-margin">
                    {letter?.step1Data?.additional ? <h4>Other</h4> : <h4 className="invisible-print">Other</h4>}
                    <Form>
                        <TextArea className="notification-letter-text-area invisible-print additional" onChange={handleChangeTextArea} value={letter?.step1Data?.additional}>  </TextArea>
                    </Form>
                    <p className="line-break invisible-screen">{letter?.step1Data?.additional}</p>
                </div>
            </Container>
        )
    }
    return (
        <div className="margin-notification-letter">
            <table>
                <thead>
                    <div className="print-margin-top-15mm"></div>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <Container className="notification-letter-logo">
                                <Image src={logo} size='medium' />
                            </Container>
                            <Container textAlign="left">
                                {renderHeaderDestination()}
                            </Container>
                            {renderLetter()}
                            <div className="page-break">
                                {renderLetterDetails()}
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

export default Step1DetailApproval;
